import * as React from "react";
import styled from "styled-components";
import { select } from "@hubper/theme";

import {
  Outer,
  selectMenuStyle,
  SHADOW_PADDING
} from "../../elements/SelectMenu";

const MenuBase = styled.div`
  ${selectMenuStyle}
  border-color: ${select.color(["grey", 1])};
`;

type Props = {
  children?: any;
  style?: React.CSSProperties;
  innerStyle?: React.CSSProperties;
};

function Menu({ children, style, innerStyle, ...rest }: Props, ref: any) {
  return (
    <Outer
      data-testid="menu-container"
      {...rest}
      style={{
        ...style,
        left: style ? (style as any).left - SHADOW_PADDING : 0,
        width: style ? (style as any).width + SHADOW_PADDING * 2 : 0
      }}
    >
      <MenuBase style={innerStyle} ref={ref}>
        {children}
      </MenuBase>
    </Outer>
  );
}

export default React.forwardRef(Menu);
